<template>
  <div style="padding-bottom: 60px">
    <Banner></Banner>
    <router-link to="/Search" target="_blank">
      <van-search background="transparent" readonly placeholder="搜行业或企业" />
    </router-link>
    <div class="pd-10 type-box" @click="show.filter = true">
      <van-icon class="icon-location" name="location-o" />
      <span class="location-text">{{ text.city }}</span>
      <span>{{ text.year }} - </span>
      <span>{{ text.category }} <van-icon name="arrow-down" /></span>
    </div>
    <!--城市&年份&行业选择-->
    <van-popup v-model="show.filter" :overlay-style="{ background: 'rgba(0,0,0,.3)' }" position="bottom" round>
      <van-cascader v-model="cascaderValue" :options="options" title="区域测评筛选" @close="show.filter = false"
        @finish="onFinish" />
    </van-popup>
    <div v-if="load.data" style="min-height: 100vh">
      <div class="loadding"><span></span> <span></span> <span></span> <span></span> <span></span></div>
    </div>
    <div v-else class="data-list">
      <!--主分类-->
      <div class="item">
        <div v-if="list.data.length > 0" class="max-title">
          <van-icon name="orders-o" />
          {{ list.title ? list.title : '-' }}
        </div>
        <ul class="data-ul">
          <li v-for="item in list.data" :key="item.id">
            <div class="box-rank-data van-clearfix">
              <div>
                <div class="show_top">TOP {{ item.show_sort }}</div>

                <router-link v-if="item.company" :to="{ name: 'Hall', query: { id: item.company_id } }" target="_blank">
                  <van-image :src="item.company.logo" class="company-logo" fit="contain" lazy-load>
                    <template v-slot:error>
                      <div class="logo-text">{{ item.rank_brand || item.company_name }}</div>
                    </template>
                  </van-image>
                </router-link>
                <router-link v-else :to="{ name: 'HallRef', query: { id: item.id } }" target="_blank">
                  <van-image class="company-logo" fit="contain" lazy-load>

                    <template v-slot:error>
                      <div class="logo-text">{{ item.rank_brand || item.company_name }}</div>
                    </template>
                  </van-image>
                </router-link>
              </div>
              <div>
                <div class="company-text">
                  <router-link v-if="item.company" :to="{ name: 'Hall', query: { id: item.company_id } }"
                    target="_blank">
                    {{ item.company_name || item.company.CompanyName }}
                  </router-link>
                  <router-link v-else :to="{ name: 'HallRef', query: { id: item.id } }" target="_blank"> {{
                    item.company_name }}</router-link>
                </div>
                <div class="tag-val-list">
                  <div v-if="item.rank_brand">
                    <span class="val-tips-sm">品牌：</span>
                    <span class="val-tips rank-brand">{{ item.rank_brand || "-" }}</span>
                  </div>
                  <div v-if="list.interpretive_unit != '-'">
                    <span class="val-tips-sm">{{ list.interpretive_prefix }} </span>
                    <span class="val-tips">{{ item.unit_val }}<span v-if="list.interpretive_unit != '-'"> {{
                      list.interpretive_unit
                    }}</span></span>
                  </div>
                </div>
                <div class="btn-box" v-if="item.company">
                  <collection :company_id="item.company_id" style="margin-bottom: 10px"></collection>
                  <connect :company="item.company"></connect>
                </div>
                <div v-else class='ref-company' @click="onRefCompany()">
                  认证展厅<van-icon name="question-o" />
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <!--子分类-->
      <div v-for="child in list.child" :key="child.id" class="item">
        <div v-if="child.data.length > 0" class="max-title">
          <van-icon name="orders-o" />
          子分类 - {{ child.title ? child.title : '-' }}
        </div>
        <ul class="data-ul">
          <li v-for="items in child.data" :key="items.id">
            <div class="box-rank-data van-clearfix">
              <div>
                <div class="show_top">TOP {{ items.show_sort }}</div>

                <template>
                  <router-link v-if='items.company' :to="{ name: 'Hall', query: { id: items.company_id } }"
                    target="_blank">
                    <van-image :src="items.company.logo" class="company-logo" fit="contain" lazy-load>
                      <template v-slot:error>
                        <div class="logo-text">{{ items.rank_brand || items.company_name }}</div>
                      </template>
                    </van-image>
                  </router-link>
                  <router-link v-else :to="{ name: 'HallRef', query: { id: items.id } }" target="_blank">
                    <van-image class="company-logo" fit="contain" lazy-load>

                      <template v-slot:error>
                        <div class="logo-text">{{ items.rank_brand || items.company_name }}</div>
                      </template>
                    </van-image>
                  </router-link>
                </template>
              </div>
              <div>
                <div class="company-text">
                  <router-link v-if="items.company" :to="{ name: 'Hall', query: { id: items.company_id } }"
                    target="_blank">
                    {{ items.company_name || items.company.CompanyName }}
                  </router-link>

                  <router-link v-else :to="{ name: 'HallRef', query: { id: items.id } }" target="_blank">
                    {{ items.company_name }}
                  </router-link>

                </div>
                <div class="tag-val-list">
                  <div v-if="items.rank_brand">
                    <span class="val-tips-sm">品牌：</span>
                    <span class="val-tips rank-brand">{{ items.rank_brand || "-" }}</span>
                  </div>
                  <div v-if="items.unit_val != '-'">
                    <span class="val-tips-sm">{{ child.interpretive_prefix }} </span>
                    <span class="val-tips">{{ items.unit_val }}<span v-if="child.interpretive_unit != '-'"> {{
                      child.interpretive_unit
                    }}</span></span>
                  </div>
                </div>
                <div class="btn-box" v-if="items.company">
                  <collection :company_id="items.company_id" style="margin-bottom: 10px"></collection>
                  <connect :company="items.company"></connect>
                </div>
                <div v-else class='ref-company' @click="onRefCompany()">
                  认证展厅<van-icon name="question-o" />
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div v-if="copywriting" class="pd-10">
      <div class="is-background">
        <div class="center">
          <img src="~@/assets/images/back_tit.png" class="bg-title">
        </div>
        <div class="is-background-p" v-html="copywriting.text">
        </div>
      </div>


      <div class="is-background organization">
        <div class="center">
          <img src="~@/assets/images/org.png" class="bg-title-org">
        </div>

        <div v-for="item in copywriting.mechanism" :key="item.title" class="organization-item">
          <div class="tag-c-box">
            <span>{{ item.type }}</span>
          </div>
          <div>
            <img :src="item.logo" class="logo-c" />
          </div>
          <div class="is-background-p" v-html="item.text">
          </div>
        </div>

      </div>


    </div>

    <div class="footer">
      <div class="center">
        <img class="logo-c" src="~@/assets/images/logo_guide.png" />
      </div>
      <div class="center">
        <p>沪ICP备16028066号-2</p>
        <p> 需要帮助？联系客服 400-6188989</p>
      </div>
    </div>

  </div>
</template>


<style scoped>
.pd-10 {
  padding: 10px;
}

.center {
  text-align: center;
}

.location-text {
  color: #FBD6BB;
  margin-left: 5px;
}

.icon-location {
  color: #F62A3A;
}


.type-box {
  border-bottom: 1px solid #FBD6BB;
  font-size: 12px;
  color: #FBD6BB;
  letter-spacing: 1px;
}

.data-list {
  padding: 10px;
  color: #ffffff;
}

.data-list .max-title {
  color: #FBD6BB;
  font-weight: bold;
  letter-spacing: 1px;
  font-size: 14px;
  margin: 15px 0 8px 0;
}

.data-list li {
  background: #FFEEE9;
  min-height: 120px;
  margin-bottom: 20px;
  position: relative;
  padding: 15px 10px;
  box-sizing: border-box;
  border-radius: 3px;
  overflow: hidden;
}

.data-list li::after {
  content: "\e660";
  position: absolute;
  top: 18px;
  right: 10px;
  display: inline-block;
  font: normal normal normal 14px/1 'vant-icon';
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  color: #FBD6BB;
}

.logo-text {
  text-align: center;
  background: #ffffff;
  color: #333333;
  font-weight: bold;
  letter-spacing: 1px;
  padding: 5px;
  height: 65px;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  align-items: center;
  border-radius: 2px;
  font-size: 12px;
  width: 100%;
  overflow: hidden;
}

.box-rank-data>div {
  float: left;
}

.box-rank-data>div:nth-child(1) {
  width: 100px;
}

.box-rank-data>div:nth-child(2) {
  width: calc(100% - 105px);
  margin-left: 5px;
  position: relative;
}

.box-rank-data>div:nth-child(2)::before {
  content: " ";
  background: url("~@/assets/images/bg_iconr.png") no-repeat;
  background-size: contain;
  height: 170px;
  width: 115px;
  position: absolute;
  top: -40px;
  right: -35px;
  user-select: none;
}


.box-rank-data .company-logo {
  width: 90px;
  height: 65px;
  display: block;
  background: white;
  object-fit: contain;
  border-radius: 3px;
}


.box-rank-data .company-text,
.box-rank-data .company-text a {
  color: #5D2811;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0;
  position: relative;
  z-index: 1;
}


.tag-box .tag-brand-text {
  min-width: 4.2rem;
  display: inline-block;
  text-align: center;
  font-weight: bold;
}

.tag-box .tag-brand {
  background: rgba(252, 214, 172, 1);
  padding: 2px;
}

.tag-box .tag-brand-num {
  background: rgba(109, 81, 216, 1);
  color: rgba(208, 196, 255, 1);
  padding: 2px;
}

.btn-box {
  margin-top: 15px;
  display: flex;
  justify-content: center;
}

.tag-val-box>div {
  float: left;
  margin-right: 5px;
  margin-top: 10px;
  background: #FFEDDF;
  border-radius: 3px;
  text-align: center;
  box-sizing: border-box;
  padding: 5px;
  font-size: 12px;
}

.tag-val-box>div:last-child {
  margin-right: 0;
}

.tag-val-box>div:nth-child(1) {
  width: 40%;
}

.tag-val-box>div:nth-child(2) {
  width: calc(100% - (5px * 2) - 40%);
}

.val-tips {
  font-size: 14x;
  color: #DF4239;
  height: 24px;
  line-height: 24px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}

.val-tips.rank-brand {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  padding: 3px 8px;
  border-radius: 3px;
  background-color: #EB0035;
  color: #F8DEBF;
  font-size: 12px;
  letter-spacing: 1px;
  margin-top: 3px;
}


.val-tips-sm {
  color: #937B70;
  margin-top: 5px;
  height: 16px;
  line-height: 16px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;

}

body .company-logo /deep/ .van-image__error {
  text-align: center;
  font-size: 12px;
  border-radius: 3px;
}


.bg-title {
  max-width: 90%;
}


.bg-title-org {
  max-width: 50%;
}

.is-background {
  background: linear-gradient(180deg, #FFF3E9 0%, #FFFFFF 25%, #FFFFFF 100%);
  padding: 18px 10px;
  border-radius: 3px;
}

.is-background-p /deep/ p {
  font-size: 12px;
  text-indent: 2rem;
  letter-spacing: 1.2px;
  line-height: 1.25rem;
  color: #8F4941;
}

.organization {
  margin-top: 25px;
}

.organization-item {
  background: #FFEDDF;
  padding: 15px 10px;
  margin-top: 25px;
  border-radius: 3px;
}

.organization-item .logo-c {
  margin: 10px auto;
  width: 150px;
  height: 80px;
  display: block;
  background: #FFFFFF;
  object-fit: contain;
  border-radius: 3px;
  padding: 10px;
  box-sizing: border-box;
}

.organization-item .tag-c-box {
  text-align: center;
  margin: 10px auto 20px;
}

.organization-item .tag-c-box>span {
  padding: 4px 1px;
  font-size: 12px;
  color: #e8b279;
  letter-spacing: 1px;
  position: relative;
  border-bottom: 1px solid rgba(232, 178, 121, 0.38);
}

.footer {
  font-size: 12px;
  color: #FFFFFF;
  margin-top: 50px;
}

.footer img {
  width: 170px;
  height: 40px;
  object-fit: contain;
}

.ref-company {
  margin-top: 10px;
  color: #DF4239;
  font-size: 12px;
}

.box-rank-data {
  position: relative;
}

.show_top {
  position: absolute;
  background: linear-gradient(270deg, #FF412B 0%, rgba(241, 0, 0, 0.73) 100%);
  color: #ffffff;
  left: 0;
  top: 0;
  z-index: 1;
  font-size: 12px;
  padding: 2px 5px;
  border-bottom-right-radius: 10px;
  border-top-left-radius: 3px;
  box-shadow: 1px 1px 4px 0px #1f1c1c2e;
}

.tag-val-list {
  margin-top: 10px;
  font-size: 14px;
  color: #918786;
}

.tag-val-list>div {
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.4) 0%, #FFFFFF 47%, rgba(255, 255, 255, 0.73) 100%);
  padding: 5px 10px;
  margin-bottom: 5px;
}
</style>

<script>
import Collection from "../components/Collection";
import Connect from "../components/Connect";
import Banner from "../components/Banner";
import confetti from "canvas-confetti";

export default {
  name: "Index",
  metaInfo: {
    title: '2026房建供应链企业综合实力TOP500首选供应商服务商品牌-优采云大数据服务平台',
    htmlAttrs: {
      lang: 'zh-CN',
      keyword: '优采云，大数据，云服务，报告',
      amp: true
    }
  },
  components: { Banner, Connect, Collection },
  data() {
    return {
      show: {
        filter: false,
      },
      load: {
        filter: false,
        data: false
      },
      cascaderValue: "",
      options: [],
      where: {
        city: null,
        year: null,
        category: null,
      },
      text: {
        city: "",
        year: "",
        category: "",
      },
      list: {
        data: []
      },
      copywriting: null,
      confettiFired: false
    }
  },
  mounted() {
    this.init()
    this.$axios.post(this.$apiconfg.get_config_child).then(({ data }) => {
      if (data.code === 1) {
        this.options = data.data
      }
    })
    this.$axios.post(this.$apiconfg.index_config).then(({ data }) => {
      if (data.code === 1) {
        this.copywriting = data.data
      }
    })

    //微信分享
    var wx = require('weixin-js-sdk');
    this.$axios.post(this.$apiconfg.wechat, {
      url: location.href
    }).then(({ data }) => {
      if (data.code === 1) {
        const config = data.data
        wx.config(config)
        wx.ready(function () {
          console.log('微信分享Ready-ok')

          const share_data = {
            title: '2026房建供应链企业综合实力TOP500首选供应商服务商品牌', // 分享标题
            desc: '中房优采平台连续第17年开展的权威研究，聚焦房地产“新TOP500”品牌格局重塑，覆盖六大领域，历经七大环节，围绕八大核心指标，为行业构建低风险、强韧性的高品质供应链体系。', // 分享描述
            link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: 'https://api-report.dichan.com/static/images/youcai-wechat-share.png', // 分享图标
            success: function () {
              // 设置成功
              console.log('自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容-ok')
            }
          }
          //自定义“分享给朋友”及“分享到QQ”按钮的分享内容（1.4.0）
          wx.updateAppMessageShareData(share_data)
          //自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0）
          wx.updateTimelineShareData(share_data)

        });
        wx.error(function (res) {
          console.log('微信分享Ready-fail')
          console.error(res)
        });
      }
    })


  },
  methods: {
    init() {
      this.load.data = true
      this.$axios.post(this.$apiconfg.m_index, this.where).then(({ data }) => {
        if (data.code === 1) {
          this.list = data.data.list
          this.text = data.data.text
        }
        this.load.data = false
        if (data.code === 1 && !this.confettiFired) {
          this.confettiFired = true
          this.launchConfetti()
        }
      })
    },
    launchConfetti() {
      const colors = ['#FF412B', '#FBD6BB', '#FFD700', '#ffffff', '#FF69B4']
      confetti({ particleCount: 80, angle: 60, spread: 55, origin: { x: 0, y: 0.65 }, colors })
      confetti({ particleCount: 80, angle: 120, spread: 55, origin: { x: 1, y: 0.65 }, colors })
    },
    onFinish({ selectedOptions }) {
      for (let i = 0; i < selectedOptions.length; i++) {
        switch (i) {
          case 0:
            this.where.city = selectedOptions[i].value
            this.text.city = selectedOptions[i].value
            break
          case 1:
            this.where.year = selectedOptions[i].value
            this.text.year = selectedOptions[i].desc
            break
          case 2:
            this.where.category = selectedOptions[i].value
            this.text.category = selectedOptions[i].text
            break
        }
      }
      this.show.filter = false;
      this.init()
    },
    onRefCompany() {
      this.$dialog.alert({
        message: '通过优采企业认证后可管理该企业信息。如果您已经认证，请耐心等待数据更新',
      });
    }
  },
}
</script>